import * as types from './types'

export const selectDay = ({commit}, dayName) => {
  commit(types.SELECT_DAY, dayName)
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/programs/actions.js